<template>
    <div class="row left-content" v-if="client">
        <div class="col-12">
            <h1>Client {{ client.name }}</h1>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="white-block">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="title mb-3">Client Details</div>
                                <ul class="text-left violation-ul">
                                    <li><b>Account ID: </b>{{ client.id }}</li>
                                    <li><b>Full name: </b>{{ client.name }}</li>
                                    <li><b>Project: </b>{{ client.project }}</li>
                                    <li><b>Status: </b>
                                        <b-badge class="mr-1" variant="primary" v-if="client.paymentCustomerId">Demand</b-badge>
                                        <b-badge variant="success" v-if="client.transferCustomerId">Supplier</b-badge>
                                        <b-badge variant="secondary" v-if="!client.paymentCustomerId && !client.transferCustomerId">Not Set</b-badge>
                                    </li>
                                    <li><b>Email: </b>{{ client.email }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="white-block plr-0">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="title mb-3">Wallet</div>
                                <div class="container">
                                    <ul class="text-left violation-ul">
                                        <li v-if="client.paymentCustomerId"><b>Payment Customer ID: </b>{{ client.paymentCustomerId }}</li>
                                        <li v-if="client.transferCustomerId"><b>Transfer Customer ID: </b>{{ client.transferCustomerId }}</li>
                                        <li><b>Balance: </b>{{ client.wallet.amount + ' ' + client.wallet.currency }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="white-block">
                    <div class="container">
                        <b-tabs content-class="mt-3" justified lazy>
                            <b-tab title="Income">
                                <incomes :id="id" :clientId="client.id" :currency="client.wallet.currency"></incomes>
                            </b-tab>
                            <b-tab title="Payments" v-if="client.paymentCustomerId">
                                <payments :id="id" :clientId="client.id"></payments>
                            </b-tab>
                            <b-tab title="Transfers" v-if="client.transferCustomerId">
                                <transfers :id="id" :client="client"></transfers>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Incomes from "@/views/admin/Wallet/Client/Money/Incomes";
import Payments from "@/views/admin/Wallet/Client/Money/Payments";
import Transfers from "@/views/admin/Wallet/Client/Money/Transfers";
export default {
    name: "One",
    props: ['id'],
    data() {
        return {
            client: null
        }
    },
    components: {
        'incomes': Incomes,
        'payments': Payments,
        'transfers': Transfers
    },
    mounted() {
        let loader = this.$loading.show();
        window.axios.get('/admin/wallet/client/' + this.id + '/view')
            .then(response => {
                    this.client = response.data.client;
                }
            )
            .finally(() => {
                loader.hide();
            });
    }
}
</script>